export default __webpack_public_path__ + "9592e1dbc8a024c8a1264727da35548f.png";